export type { LatestTransactionsTableTranslations } from "./latest-transactions-table-pt-br";

export { LATEST_TRANSACTIONS_TABLE_PT_BR } from "./latest-transactions-table-pt-br";
export { LATEST_TRANSACTIONS_TABLE_EN_US } from "./latest-transactions-table-en-us";
export { LATEST_TRANSACTIONS_TABLE_ES_MX } from "./latest-transactions-table-es-mx";
export { LATEST_TRANSACTIONS_TABLE_FR_FR } from "./latest-transactions-table-fr-fr";
